import "./utils/sentry"
import React from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import App from "./containers/App"
import MaintenanceError from "./components/pages/MaintenanceError"
import { logErrorMessage } from "./utils/errors"

const rootElement = document.getElementById("root")
if (!rootElement) {
  throw new Error("Root element not found")
}
const root = createRoot(rootElement)
if (
  process.env.REACT_APP_ENV !== "production" &&
  window.location.hostname === "coastlineacademy"
) {
  logErrorMessage("Attempting to run non-production build on production")
  root.render(<MaintenanceError />)
} else {
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
  )
}
